import {
  Button,
  InputAdornment,
  Popover,
  MenuItem,
  TextField,
  Backdrop,
  CircularProgress
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import moment from "moment";
import IconButton from "@mui/material/IconButton";

import BottomButton from "../components/BottomButton";
import { useStyles } from "../styles/useStyles";
import icon_search from "../../assets/icon_search.svg";
import { getYears } from "../utils";
import PickerWithButtonField from "../overightMui/DatePickerButton";
import icon_bike_type from "../../assets/icon_bike_type.svg";
import icon_bike_brand from "../../assets/icon_bike_brand.svg";
import icon_bike_category from "../../assets/icon_bike_category.svg";
import icon_insured_time from "../../assets/icon_insured_time.svg";
import banner_step2 from "../../assets/banner-step2.svg";
import checklist_icon from "../../assets/check_ok_icon.svg";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { add } from "lodash";


export default function Step_1({ state, dispatch, platform }) {
  const [openBrands, setOpenBrands] = useState(null);
  const [openProductLine, setOpenProductLine] = useState(null);
  const [openAutocomplete, setOpenAutocomplete] = useState(null);
  const [open_loai_xe, setOpen_loai_xe] = useState(null);
  const [openInsurancePeriod, setOpenInsurancePeriod] = useState(false);
  const [searchBrandInput, setSearchBrandInput] = useState("");
  const [searchProductLineInput, setSearchProductLineInput] = useState("");

  const {
    errors,
    resultBrandsOnSearch,
    vehicleInfo,
    resultProductLinesOnSearch,
    insuranceInfo,
    loading_dong_xe,
    configs,
    foundPackage,
    validProductLine,
    currentStep
  } = state;

  const { type, brand, productLine, period } = vehicleInfo;
  const classes = useStyles();
  const [valueSlider, setValueSlider] = useState(50);
  const [debouncedValue, setDebouncedValue] = useState(0);
  const { vehicleTypes } = configs;

  useEffect(() => {
    dispatch("inital_step1");
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const stepErrors = errors.step1 || []
    if (type && brand && productLine && !(stepErrors.includes("invalid_product_line")) && validProductLine) {
      setOpenInsurancePeriod(true)
    }
  }, [validProductLine])

  useEffect(() => {
    if (vehicleTypes) {
      setOpen_loai_xe(true);
    }
  }, [vehicleTypes]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(valueSlider);
    }, 600);

    return () => {
      clearTimeout(handler);
    };
  }, [valueSlider]);

  useEffect(() => {
    if (debouncedValue == valueSlider && (type && brand && productLine && period)) {
      dispatch("getPackage");
    }
  }, [debouncedValue]);

  useEffect(() => {
    dispatch("validatePage");
  }, [type, brand, productLine, foundPackage]);

  useEffect(() => {
    if (type && brand && productLine && period) {
      dispatch("getPackage");
    }
  }, [vehicleInfo]);

  useEffect(() => {
    if (productLine) {
    dispatch("checkValidProductLine");
    }
  }, [productLine])

  return (
    <>
      <div className={classes.wrapper} style={{ display: "flex", flexDirection: "column", gap: 16 }}>
        <TextField
          select
          size="small"
          fullWidth
          SelectProps={{
            open: open_loai_xe,
            onOpen: () => setOpen_loai_xe(true),
            onClose: () => {
              setOpen_loai_xe(false);
            },
            MenuProps: {
              sx: {
                "& .MuiPaper-root": {
                  // width: "-webkit-fill-available",
                  minWidth: "min(650px , calc(100% - 32px)) !important"
                },
              },

            },
          }}
          sx={{
            "& .MuiInputBase-root": {
              borderRadius: "8px",
              height: "44px",
              background: "white",
            },


            "& fieldset": {
              borderRadius: "8px",
            },

            // marginBottom: "12px",
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <img src={icon_bike_type} alt="icon_motorbikeTF" />
              </InputAdornment>
            )
          }}
          value={vehicleInfo?.type?.id || "_"}
          onChange={(e) => {
            dispatch({
              type: "onChangeVelhicleInfor",
              name: "type",
              value: configs.vehicleTypes?.find((i) => i.id === e.target.value),
            });
            const element_hang_xe = document.getElementById("hang_xe");
            setOpenBrands(element_hang_xe);
          }}
        >
          <MenuItem value="_" style={{ display: "none" }}>
            <div style={{ fontSize: "14px", color: "#343A40" }}>
              Chọn loại xe
            </div>
          </MenuItem>
          {configs.vehicleTypes?.map((item, index) => (
            <MenuItem
              key={item.vehicleType}
              value={item.id}
              style={{ width: "100%" }}
            // style={getStyles(name, personName, theme)}
            >
              {item.title}
            </MenuItem>
          ))}
        </TextField>
        <div>
          <Button
            id="hang_xe"
            sx={{
              width: "100%",
              textTransform: "none",
              border: "1px solid #D2D2D2",
              borderColor: "#D2D2D2",
              borderRadius: "8px",
              justifyContent: "space-between",
              color: vehicleInfo?.brand?.title
                ? "rgb(0, 0, 0, 0.87)"
                : "#343A40",
              height: "44px",
              background: "white",
              "&:hover": { background: "white" },
            }}
            onClick={(e) => {
              setOpenBrands(e.currentTarget);
            }}
          >
            <img
              src={icon_bike_brand}
              alt="icon_motorbikeTF"
              style={{ marginLeft: "4px" }}
            />
            <div
              style={{
                width: "-webkit-fill-available",
                textAlign: "left",
                paddingLeft: "8px",
              }}
            >
              {vehicleInfo?.brand?.title || "Chọn hãng xe"}
            </div>
            <ArrowDropDownIcon />
          </Button>
          <Popover
            open={Boolean(openBrands)}
            anchorEl={openBrands}
            onClose={() => setOpenBrands(null)}
            sx={{ maxWidth: "650px" }}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          >
            <div className={classes.textField_search_select}>
              <TextField
                placeholder="Nhập hãng xe"
                fullWidth
                size="small"
                value={searchBrandInput}
                sx={{
                  "& .MuiInputBase-input::placeholder": {
                    fontStyle: "italic",
                  },
                  "& .MuiInputBase-root": {
                    borderRadius: "24px ",
                  },
                }}
                onChange={(e) => {
                  const value = e.target.value || "";
                  setSearchBrandInput(value);
                  dispatch({
                    type: "onSearchBike",
                    name: "brand",
                    key: e.target.value || "",
                  });
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <img src={icon_search} alt="Icon_search" width={20} />
                    </InputAdornment>
                  ),
                  endAdornment: searchBrandInput && (
                    <InputAdornment position="end">
                      <IconButton
                        size="small"
                        onClick={() => {
                          setSearchBrandInput("");
                          dispatch({
                            type: "onSearchBike",
                            name: "brand",
                            key: "",
                          });
                        }}
                        sx={{
                          color: "#969696",
                          width: 20,
                          height: 20,
                          "& .MuiSvgIcon-root": {
                            fontSize: 16
                          },
                        }}
                      >
                        ✕
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
            </div>

            <div
              style={{
                width: "calc(100vw - 48px)",
                maxWidth: "650px",
                padding: "8px",
              }}
            >
              <div style={{ maxHeight: "65vh" }}>
                {resultBrandsOnSearch?.map((i) => (
                  <MenuItem
                    key={i.uid || "test"}
                    value={i.uid}
                    onClick={() => {
                      dispatch({
                        type: "onChangeVelhicleInfor",
                        name: "brand",
                        value: i,
                      });
                      setOpenBrands(null);
                      const element_dong_xe =
                        document.getElementById("dong_xe");
                      setOpenProductLine(element_dong_xe);
                    }}
                    style={{
                      fontSize: "14px",
                      minHeight: "30px",
                      paddingLeft: "8px",
                      whiteSpace: "normal",
                      overflow: "auto",
                      letterSpacing: 0,
                    }}
                  >
                    {i.title || ""}
                  </MenuItem>
                ))}
              </div>
            </div>
          </Popover>
        </div>
        <div>
          <Button
            sx={{
              width: "100%",
              textTransform: "none",
              border: "1px solid #D2D2D2",
              borderColor: "#D2D2D2",
              borderRadius: "8px",
              justifyContent: "space-between",
              color: vehicleInfo?.productLine?.title
                ? "rgb(0, 0, 0, 0.87)"
                : "#343A40",
              height: "44px",
              background: "white",
              "&:hover": { background: "white" },
            }}
            id="dong_xe"
            onClick={(e) => {
              setOpenProductLine(e.currentTarget);
            }}
          >
            <img
              src={icon_bike_category}
              alt="icon_motorbikeTF"
              style={{ marginLeft: "4px" }}
            />
            <div
              style={{
                width: "-webkit-fill-available",
                textAlign: "left",
                paddingLeft: "8px",
              }}
            >
              {vehicleInfo?.productLine?.title || "Chọn dòng xe"}
            </div>
            <ArrowDropDownIcon />
          </Button>
          <Popover
            open={Boolean(openProductLine)}
            anchorEl={openProductLine}
            onClose={() => setOpenProductLine(null)}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          >
            <div
              style={{
                width: "calc(100vw - 48px)",
                maxWidth: "650px",
                padding: "8px",
              }}
            >
              <Backdrop
                style={{
                  color: "#fff",
                  borderRadius: "5px",
                  position: "absolute",
                  zIndex: "2",
                }}
                open={!!loading_dong_xe}
              >
                <CircularProgress color="inherit" />
              </Backdrop>
              <div className={classes.textField_search_select}>
                <TextField
                  placeholder="Nhập dòng xe"
                  fullWidth
                  value={searchProductLineInput}
                  size="small"
                  sx={{
                    "& .MuiInputBase-input::placeholder": {
                      fontStyle: "italic",
                    },
                    "& .MuiInputBase-root": {
                      borderRadius: "24px ",
                    },
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <img src={icon_search} alt="Icon_search" width={20} />
                      </InputAdornment>
                    ),
                    endAdornment: searchProductLineInput && (
                      <InputAdornment position="end">
                        <IconButton
                          size="small"
                          onClick={() => {
                            setSearchProductLineInput("");
                            dispatch({
                              type: "onSearchBike",
                              name: "productLine",
                              key: "",
                            });
                          }}
                          sx={{
                            color: "#969696",
                            width: 20,
                            height: 20,
                            "& .MuiSvgIcon-root": {
                              fontSize: 16
                            },
                          }}
                        >
                          ✕
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                  onChange={(e) => {
                    setSearchProductLineInput(e.target.value);
                    dispatch({
                      type: "onSearchBike",
                      name: "productLine",
                      key: e.target.value || "",
                    });
                  }}
                />
              </div>
              <div style={{ maxHeight: "60vh" }}>
                {resultProductLinesOnSearch.map((i) => (
                  <MenuItem
                    key={i.uid}
                    value={i.uid}
                    onClick={() => {
                      setOpenProductLine(null);
                      dispatch({
                        type: "onChangeVelhicleInfor",
                        name: "productLine",
                        value: i,
                      });
                    }}
                    style={{
                      fontSize: "14px",
                      minHeight: "30px",
                      paddingLeft: "8px",
                      whiteSpace: "normal",
                      overflow: "auto",
                      letterSpacing: 0,
                    }}
                  >
                    {i.title}
                  </MenuItem>
                ))}
              </div>
            </div>
          </Popover>
        </div>
        <div>
          <TextField
            select
            size="small"
            fullWidth
            SelectProps={{
              open: openInsurancePeriod,
              onOpen: () => setOpenInsurancePeriod(true),
              onClose: () => {
                setOpenInsurancePeriod(false);
              },
              MenuProps: {
                sx: {
                  "& .MuiPaper-root": {
                    minWidth: "min(650px , calc(100% - 32px)) !important"
                    // maxWidth: "650px"
                  },
                },
              },
            }}
            sx={{
              "& .MuiInputBase-root": {
                borderRadius: "8px",
                height: "44px",
                background: "white",
              },

              "& fieldset": {
                borderRadius: "8px",
              },

              marginBottom: "12px",
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <img src={icon_insured_time} alt="icon_motorbikeTF" />
                </InputAdornment>
              )
            }}
            value={vehicleInfo?.period || "_"}
            onChange={(e) => {
              dispatch({
                type: "onChangeVelhicleInfor",
                name: "period",
                value: configs.yearsOfInsurance?.find((i) => i.id === e.target.value),
              });
              setOpenAutocomplete(true);
            }}
          >
            <MenuItem value="_" style={{ display: "none" }}>
              <div style={{ fontSize: "14px", color: "#343A40" }}>
                Chọn thời hạn dịch vụ
              </div>
            </MenuItem>
            {configs.yearsOfInsurance?.map((item, index) => (
              <MenuItem
                value={item.id}
                style={{ width: "100%" }}
              // style={getStyles(name, personName, theme)}
              >
                {item.title}
              </MenuItem>
            ))}
          </TextField>
          <div className={classes.box_days} style={{ justifyContent: "space-between", display: "flex", flexDirection: "row", gap: 15 }}>
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                gap: 5,
                justifyContent: "space-between"
              }}
            >
              Ngày bắt đầu
              <div style={{
                backgroundColor: "#ffffffff",
              }}>
                <PickerWithButtonField
                  value={moment(insuranceInfo?.validFrom).toDate()}
                  dispatch={dispatch}
                />
              </div>
            </div>
            <div
              style={{
                borderRadius: "8px",
                width: "100%",
                display: "flex",
                flexDirection: "column",
                gap: 5,
                justifyContent: "space-between"
              }}
            >
              Ngày kết thúc
              <div style={{
                backgroundColor: "#eeeeeeff",
              }}>
                <PickerWithButtonField
                  disabled={true}
                  value={moment(insuranceInfo?.validUntil).toDate()}
                />
              </div>
            </div>
          </div>
          {(!!foundPackage?.packageId && errors.step1?.length === 0) ? (
            <div style={{
              borderRadius: 16,
              padding: 10,
              display: "flex",
              flexDirection: "column",
              gap: 5,
              border: "0.5px #D2D2D2",
              backgroundColor: "white",
              marginTop: 16
            }}>
              <div style={{ display: "flex", justifyContent: "space-between", fontWeight: 600 }}>
                <div>Phí dịch vụ</div>
                <div style={{ fontSize: 16, color: "#FB7800" }}>{`${foundPackage?.packagePrice || 0}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}{" "}VNĐ</div>
              </div>
              <div style={{
                display: "flex",
                flexDirection: "column",
                gap: 5,
                justifyContent: "space-between"
              }}>
                <span style={{ fontWeight: 600 }}>Quyền lợi</span>
                <div style={{
                  display: "flex", justifyContent: "space-between", gap: 10
                }}>
                  <img src={checklist_icon} alt="checklist_icon" width={16} height={16} />
                  <div style={{
                    textAlign: "justify", wordBreak: "break-word",
                    overflowWrap: "break-word",
                    flex: 1,
                    alignContent: "left"
                  }}>Hỗ trợ bơm vá lốp xe miễn phí</div>
                </div>
                <div style={{
                  display: "flex", justifyContent: "space-between", gap: 10
                }}>
                  <img src={checklist_icon} alt="checklist_icon" width={16} height={16} />
                  <div style={{
                    textAlign: "justify", wordBreak: "break-word",
                    overflowWrap: "break-word",
                    flex: 1,
                    alignContent: "left",
                    lineHeight: "140%"
                  }}>Hỗ trợ miễn phí kích bình khởi động xe khi bình không sạc</div>
                </div>
                <div style={{
                  display: "flex", justifyContent: "space-between", gap: 10
                }}>
                  <img src={checklist_icon} alt="checklist_icon" width={16} height={16} />
                  <div style={{
                    textAlign: "justify", wordBreak: "break-word",
                    overflowWrap: "break-word",
                    flex: 1,
                    alignContent: "left"
                  }}>Hỗ trợ tiếp xăng</div>
                </div>
                <div style={{
                  display: "flex", gap: 10
                }}>
                  <img src={checklist_icon} alt="checklist_icon" width={16} height={16} />
                  <div style={{
                    textAlign: "justify", wordBreak: "break-word",
                    overflowWrap: "break-word",
                    flex: 1,
                    alignContent: "left",
                    lineHeight: "140%"
                  }}>Vận chuyển miễn phí 50km đối với phương tiện dưới 175cc và
                    300km đối với phương tiện trên 175cc từ vị trí của khách hàng.
                    Phụ thu khách hàng 100,000VNĐ trên 10km khi vượt quá giới hạn km được miễn phí.
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div style={{ padding: "43px 27px", justifyContent: "center", alignItems: "center", display: "flex" }}>
              <img src={banner_step2} alt="banner_step2" />
            </div>
          )}

        </div>
      </div >
      <BottomButton
        disabled={errors.step1?.length > 0}
        onBack={() => dispatch("comeBackPage")}
        onClick={() => dispatch("nextPage")}
        title="Tiếp tục"
      />
    </>
  );
}
